import { useParams } from "react-router";
import { LegalEntityAuditGroupDraft, LegalEntityAuditGroupDraftOverviewModel } from "./LegalEntityAuditGroupOverview.types";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { getAuditGroupDraftOverviewQueryKey, useAuditGroupDraftSelection } from "./useAuditGroupDraftSelection";

export default function useLegalEntityAuditGroupDraftOverviewHooks() {
    const { id } = useParams<{ id: string }>();
    const queryKey = getAuditGroupDraftOverviewQueryKey(id!);

    let { isLoading, data, refetch } = useDotLegalQuery<LegalEntityAuditGroupDraftOverviewModel>(queryKey);
    const { updateSelectedLegalEntities } = useAuditGroupDraftSelection(id!);

    if (data) {
        data.selectedEntities = data.selectedEntities.map(
            (x) => new LegalEntityAuditGroupDraft(x.legalEntityId, x.contactId, x.additionalRecipientIds, x.systemIds)
        );
    }

    function onAuditGroupUpdated() {
        refetch();
    }

    return {
        id,
        data,
        isLoading,
        onAuditGroupUpdated,
        updateSelectedLegalEntities,
        refetch,
    };
}
